import React from 'react'
;
import { Link } from 'react-router-dom';

const News = () => {

    

    return (
        <div className="news-event-area">
            <div className="container">
                <div className="row">
                    <h2 className="title-default-center title-bar-counter">Latest News</h2>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 news-inner-area">
                        <ul className="news-wrapper">
                            <li className="wow bounceInUp" data-wow-duration="2s" data-wow-delay=".1s">
                                <div className="news-img-holder">
                                    <a href="#"><img src="/images/AR.jpg" className="img-responsive" alt="news" /></a>
                                </div>
                                <div className="news-content-holder">
                                    <h3><a href="single-news.html">Augmented Reality Startup Course</a></h3>
                                    <p className>Build amazing AR apps for Android, iPhone, Windows, Linux and Mac.<br />
                                        Learn to integrate complex 3D models with your Augmented Reality application</p>
                                </div>
                            </li>
                            <li className="wow bounceInUp" data-wow-duration="2s" data-wow-delay=".1s">
                                <div className="news-img-holder">
                                    <a href="#"><img src="/images/hairSty.jpg" className="img-responsive" alt="news" /></a>
                                </div>
                                <div className="news-content-holder">
                                    <h3><a href="single-news.html">Fashion Designing &amp; Parlor &amp; Hair Style Courses</a></h3>
                                    <p>One Month to 12 Months Courses, More Information Visit to Your Nearest ITT Council Authorise
                                        Training Center</p>
                                </div>
                            </li>
                            <li className="wow bounceInUp" data-wow-duration="2s" data-wow-delay=".1s">
                                <div className="news-img-holder">
                                    <a href="#"><img src="/images/office.jpg" className="img-responsive" alt="news" /></a>
                                </div>
                                <div className="news-content-holder">
                                    <h3><a href="single-news.html">Registered Your Training Center with New Plan</a></h3>
                                    <p>
                                        1. Registered Your Computer Institute<br />
                                        2. Registered Your Technical &amp; ITI Institute<br />
                                        3. Registered Your GIS Institute<br />
                                        4. Registered Your Fashion Designing Institute<br />
                                        5. Registered Your Parlor Institute
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 news-inner-area">
                        <ul className="news-wrapper">
                            <li className="wow bounceInUp" data-wow-duration="2s" data-wow-delay=".1s">
                                <div className="news-img-holder">
                                    <a href="#"><img src="/images/news-img.jpg" className="img-responsive" alt="news" /></a>
                                </div>
                                <div className="news-content-holder">
                                    <h3><a href="single-news.html">Start Remote Sensing and GIS Training Programs</a></h3>
                                    <p className>One Month to 12 Months Training Programs, More Information Visit to Your Nearest ITT
                                        Council Authorise Training Center.</p>
                                </div>
                            </li>
                            <li className="wow bounceInUp" data-wow-duration="2s" data-wow-delay=".1s">
                                <div className="news-img-holder">
                                    <a href="#"><img src="/images/news-img5.jpg" className="img-responsive" alt="news" /></a>
                                </div>
                                <div className="news-content-holder">
                                    <h3><a href="single-news.html">Start 3D &amp; Multimedia Animation Training Programs</a></h3>
                                    <p>6 Month to 2 Years Training Programs, More Information Visit to Your Nearest ITT Council Authorise
                                        Training Center.</p>
                                </div>
                            </li>
                            <li className="wow bounceInUp" data-wow-duration="2s" data-wow-delay=".1s">
                                <div className="news-img-holder">
                                    <a href="#"><img src="/images/admission.jpg" className="img-responsive" alt="news" /></a>
                                </div>
                                <div className="news-content-holder">
                                    <h3><a href="single-news.html">Start Admission All Course</a></h3>
                                    <p>
                                        Unlock your potential with ITT Council's esteemed programs and become a part of the future of technology and innovation.<br /><br />
                                        <b>Apply now to advance your career in technology and innovation!</b>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="d-flex justify-content-center p-5 ">
                        <div className="news-btn-holder">
                            <Link to='/allcourses' className="view-all-accent-btn ">View All</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export { News };